<template>
  <div class="main-content">
    <!-- Section: inner-header -->
    <section
      class="inner-header divider layer-overlay overlay-dark-5 pt-100"
      data-parallax-ratio="0.7"
      data-bg-img="images/202208/Sarah118.jpg"
    >
      <div class="container pt-100 pb-50">
        <!-- Section Content -->
        <div class="section-content pt-100">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">VIDEO ESERCIZI</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container pt-40 pb-40">
        <div class="input-group">
          <input
            type="text"
            placeholder="Cerca"
            class="form-control search-input"
            v-model="searchFilter"
          />
          <span class="input-group-btn">
            <button type="submit" class="btn search-button">
              <i class="fa fa-search"></i>
            </button>
          </span>
        </div>

        <div v-if="searchFilter && searchFilter.length > 2">
          
          <h3 class="text-uppercase font-weight-800">RISULTATI PER: 
              <span class="text-theme-colored"> {{ searchFilter }}</span></h3>

          <div
          class="t-a-center mt-20"
          v-if="videoCollectionFiltered.length == 0"
        >
          <h4 class="text-uppercase font-weight-800">NESSUN RISULTATO.</h4>
        </div>
        
          <div class="list-group mt-20">
          <button
            type="button"
            class="list-group-item dark-group"
            v-bind:class="{ active: video == videoToView }"
            v-for="video in videoCollectionFiltered"
            v-on:click="OpenVideo(video)"
            :key="video.id"
          >
            {{ video.Title }}
          </button>
        </div>
        </div>
        
       

        <div class="mt-20 mb-20 pt-20 pb-20">
          
          <h3 class="text-uppercase font-weight-800">NAVIGA I  
              <span class="text-theme-colored"> VIDEO</span></h3>


          <div id="accordion1" class="panel-group accordion">
            <div id="accordion1" class="panel-group accordion">
              <div
                class="panel"
                v-for="grouped in groupedCollection"
                :key="grouped.Title"
              >
                <video-group-item
                  :name="'firstLevel' + grouped.Title"
                  v-bind:itemView="grouped"
                  accordionParentName="accordion1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <video-modal
      v-bind:videoView="videoToView"
      v-on:closeModal="videoToView = null"
    />
  </div>
</template>

<style scoped>
.t-a-center {
  text-align: center;
}
#about .title.line-bottom {
  padding-bottom: 0;
  margin-bottom: 10px;
}
#about .title.line-bottom::after {
  height: 2px;
  width: 100%;
}

.mh-auto {
  max-height: initial !important;
}

.sub-panel-title a {
  color: #ee163b;
}

.thirth-panel-title a {
  color: white;
}
</style>

<script>
import axios from "axios";
import VideoModal from "../../components/VideoModal.vue";
import VideoGroupItem from "../auth/VideoGroupItem.vue";

export default {
  name: "VideoList",
  components: {
    VideoModal,
    VideoGroupItem,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
      videoToView: null,
      searchFilter: null,
      videoCollection: [],
      groupedCollection: [],
    };
  },
  methods: {
    OpenVideo(video) {
      this.videoToView = video;
    },
    compare(a, b) {
      if (a.Title < b.Title) return -1;
      if (a.Title > b.Title) return 1;
      return 0;
    },
  },
  computed: {
    videoCollectionFiltered: function () {
      let searchFilterText = this.searchFilter;
      if(searchFilterText != "" && searchFilterText){
      return this.videoCollection.filter(function (video) {
        if (searchFilterText != null && searchFilterText != "") {
          return video.Title?.toLowerCase().includes(
            searchFilterText?.toLowerCase()
          );
        } else {
          return true;
        }
      });
    }
    return [];
    },
  },
  mounted() {
    axios
       .get(process.env.VUE_APP_API_URL + "/videos?_limit=-1")
      //.get(process.env.VUE_APP_API_URL + "/video/getallvideo")
      .then((response) => {
        this.videoCollection = response.data.sort(this.compare);
        this.groupedCollection = raggruppaPerCampo(
          this.videoCollection,
          "GroupString"
        );
        console.log(this.groupedCollection);
      });
  },
};

function raggruppaPerCampo(array, campo) {
  const raggruppamenti = {};

  array.forEach((elemento) => {
    const keys = elemento[campo] != null ? elemento[campo].split("-") : [''];
    let livello = raggruppamenti;
    keys.forEach((key) => {
      if(key == ''){
        key = 'Tutti';
      }
      if (!livello[key]) {
        livello[key] = {};
      }
      livello = livello[key];
    });

    if (!livello["_elementi"]) {
      livello["_elementi"] = [];
    }
    livello["_elementi"].push(elemento);
  });

  return convertiInArray(raggruppamenti);
}
function convertiInArray(obj, level = 1) {
  return Object.keys(obj).map((key) => {
    if (key === "_elementi") {
      return obj[key];
    }
    return {
      title: key,
      level: level,
      PanelClass:
        level == 2
          ? "sub-panel-title"
          : level == 3
          ? "thirth-panel-title"
          : "panel-title",
      elements: convertiInArray(obj[key], level + 1),
    };
  });
}
</script>